import React from 'react'
import { Form, Input, Select, InputNumber } from 'antd'
import PropTypes from 'prop-types'
import { EnFormItem } from '../../shared/LocalizedFields'

const TraditionsCollectionsForm = ({
  form,
  titleKaz,
  titleRus,
  titleEng,
  setImageFile,
  imageFileRef,
  traditions,
  selectedTraditions
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <FormItem
        key="titleKaz"
        label="Название (каз)"
        name="titleKaz"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название на казахском`
          }
        ]}
        initialValue={titleKaz}
      >
        <Input placeholder="Название (каз)" />
      </FormItem>
      <FormItem
        key="titleRus"
        label="Название (рус)"
        name="titleRus"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название на русском`
          }
        ]}
        initialValue={titleRus}
      >
        <Input placeholder="Название (рус)" />
      </FormItem>
      <EnFormItem
        name="titleEng"
        label="Название (англ)"
        initialValue={titleEng}
      />
      <FormItem
        key="traditions"
        label="Традиции"
        name="traditions"
        rules={[
          {
            required: false,
            message: `Пожалуйста, выберите традиции`
          }
        ]}
        initialValue={selectedTraditions?.map(item => (item ? item?.id : item))}
      >
        <Select
          placeholder="Выберите традиции"
          mode="multiple"
          showSearch
          optionFilterProp="children"
        >
          {traditions?.map(item => (
            <Select.Option key={item.id} value={item.id}>
              {item.titleRus} - {item.titleKaz}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
      <div style={{ marginBottom: '3%' }}>
        <>Изображение</>
        <input
          type="file"
          accept="image/*"
          ref={imageFileRef}
          onChange={event => setImageFile(event.target.files[0])}
        />
      </div>
    </Form>
  )
}

TraditionsCollectionsForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired
}

export default TraditionsCollectionsForm
